import * as React from 'react';
import TopBar from "../../components/TopBarV2";
import Container from '@mui/material/Container';
import GlobalStyles from "@mui/material/GlobalStyles/GlobalStyles";
import Grid from "@mui/material/Grid/Grid";
import Button from "@mui/material/Button/Button";
import {useNavigate, useLocation } from 'react-router-dom';
import ProjectListItem from "../../components/project-list-item";
import ProjectGridItem from "../../components/project-grid-item";
import moment from 'moment';
import firebase from "../../firebase/firebase";
import CircularProgress from "@mui/material/CircularProgress/CircularProgress";
import Dialog from "@mui/material/Dialog/Dialog";
import DialogTitle from "@mui/material/DialogTitle/DialogTitle";
import Stack from "@mui/material/Stack/Stack";
import Typography from "@mui/material/Typography/Typography";
import IconButton from "@mui/material/IconButton/IconButton";
import CloseIcon from '@mui/icons-material/Close';
import Autocomplete from '@mui/material/Autocomplete';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import DialogContent from "@mui/material/DialogContent/DialogContent";
import DialogContentText from "@mui/material/DialogContentText/DialogContentText";
import DialogActions from "@mui/material/DialogActions/DialogActions";
import Portal from "@mui/material/Portal";
import {AuthUserContext} from "../../providers/AuthProvider";
import SearchIcon from '@mui/icons-material/Search';
import GridViewSharpIcon from '@mui/icons-material/GridViewSharp';
import ReorderSharpIcon from '@mui/icons-material/ReorderSharp';
import {numberFormatter} from '../../utils/numberFormat'
const preTags = [
    'All Genre',
    'Action',
    'Adult',
    'Adventure',
    'Animation',
    'Anime',
    'Biography',
    'Cdrama',
    'Comedy',
    'Crime',
    'Documentary',
    'Drama',
    'Family',
    'Fantasy',
    'Game-Show',
    'History',
    'Horror',
    'Indie Shorts',
    'Kdrama',
    'Music',
    'Musical',
    'Mystery',
	  'News',
    'Reality-Tv',
    'Romance',
    'Sci-Fi',
    'Short',
    'Short Film',
    'Sport',
    'Superhero',
    'Thriller',
    'Talk-Show', 
    'War',  
    'Western', 
      
];

const geoTags = [
  "All Regions",
  "Africa",
	"America",
	"Asia",
	"Australia",
  "Brazil",
  "China",
  "Europe",
	"India",
	"Nigeria",
  "South Korea",
	"Spain",
	"U.K",
	"U.S.A",
	"Other",
];

const INVESTMENT_BANDS = [
  {
    min: 0,
  },
  {
    min: 1000,
    max: 100000
  },
  {
    min: 100000,
    max: 500000
  },
  {
    min: 500000,
    max: 1000000
  },
  {
    min: 1000000,

  },

]
const filterStyleDiv = {
  background : "#E3E8F0" ,
  border: "1px solid #E3E8F0",
  borderRadius: "50px",
  outline : "none",
  color : "#204488",
  alignItems : "center",
  padding: "0px 12px"
}

const filterStyleSelect = {
  background : "#E3E8F0" ,
  border: "1px solid #E3E8F0",
  borderRadius: "50px",
  fontSize : "16px",
  outline : "none",
  color : "#204488",
  fontFamily :"ABeeZee"
}

export default function MainComponent(){
  const navigator = useNavigate();
  const location = useLocation();
    const { user, profile} = React.useContext(AuthUserContext);
    const [searchProject , setSearchProject] = React.useState('')
    const [myProject , setMyProject] = React.useState('')
    const [view, setView] = React.useState('Grid')
    const [viewProject, setViewProject] = React.useState('Grid')
    const [list, setList] = React.useState([])
    const [myList, setMyList] = React.useState([])
    const [loading, setLoading] = React.useState(true)
    const [value, setValue] = React.useState(0);
    const [filterData, setFilterData] = React.useState([])
    const [fState , setFState] =  React.useState(false)
    const [ Region , setRegion] = React.useState('All Regions');
    const [ Genre , setGenre] = React.useState('All Genre');
    const [ band , setBand] = React.useState(0);
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const selectRegion  = (event) => {
      setRegion(event.target.value);
    };

    const selectGenre  = (event) => {
      setGenre(event.target.value);
    };

    const selectBand = (event) => {
      setBand(event.target.value);
    };

    const search = () => {
     
      if (searchProject === '') {
        setFilterData([...list])
      } else {
        const regex = new RegExp(searchProject);
        setFilterData(list.filter((u) => regex?.test(u.title) || regex?.test(u.creatorName) ));
      }
    }


    const searchMyProject = () => {
     
      if (myProject === '') {
        setFilterData([...myList])
      } else {
        const regex = new RegExp(myProject);
        setFilterData(myList.filter((u) => regex?.test(u.title) || regex?.test(u.creatorName) ));
      }
    }
  
  let projectPattern = /dashboard/;
  const [open, setOpen] = React.useState(false);

    React.useEffect(() => {
      setLoading(false)
      setList([])
      setMyList([])
      let myProjectIds = []
      let myProjects = []

      if(projectPattern.test(location.pathname)) {
        firebase.firestore().collection('receipts')
        .where('createdBy', '==', profile.uid)
        .where('status', '==', 'received')
        .get()
        .then(async (orders) => {
          orders.docs.forEach(d => {
            myProjectIds.push(d.data().projectId)
          })

          const projectRef = firebase.firestore().collection('projects').orderBy('createdAt', "desc");

          projectRef.where('status', '==', 'approved')
          .get()
          .then(async (projectsList)=> {
            const profileRef = firebase.firestore().collection('users').doc(profile.id);

            const profileSnapshot = await profileRef.get();

            if (profileSnapshot && !profileSnapshot.data().workHistory) {
                setOpen(true)
            }
            const projects = []
            if(projectsList && projectsList.docs.length > 0) {
              projectsList.docs.forEach(d => {
                if(myProjectIds.indexOf(d.id) > -1) {
                  myProjects.push({id: d.id, ...d.data()})
                } else {
                  projects.push({id: d.id, ...d.data()})
                }
              })
            }
            setList(projects);
            setMyList(myProjects);
            setLoading(false);
          });
        })
        .catch((e) => {
          setLoading(false)
        });
      } else {

          const projectRef = firebase.firestore().collection('projects').orderBy('createdAt', "desc");

          projectRef.where('status', '==', 'approved').get().then(async (projectsList)=> {
            const profileRef = firebase.firestore().collection('users').doc(profile.id);
            const profileSnapshot = await profileRef.get();
            if (profileSnapshot && !profileSnapshot.data().workHistory) {
                setOpen(true)
            }
            const projects = []
            if(projectsList && projectsList.docs.length > 0) {
              projectsList.docs.forEach(d => {
                projects.push({id: d.id, ...d.data()})
              })
            }
            setList(projects);
            setMyList(myProjects);
            setLoading(false);
          });
      }
    }, [location.pathname])

    // console.log(list)
    const filteredProjects =  list.filter((item) => {return ( searchProject === "" ? true : (item.title.toLowerCase()).startsWith(searchProject.toLowerCase())) && (Genre === 'All Genre' ? true : item.genre.includes(Genre)) && (Region === 'All Regions' ? true : item.primaryFilmLocation === Region) && ( band === 0 ? true : (item.budget >= INVESTMENT_BANDS[band].min && (INVESTMENT_BANDS[band].max === undefined ? true : item.budget < INVESTMENT_BANDS[band].max)))})
    const myFilteredProjects = myProject === "" ? myList : myList.filter((item) => {return (item.title.toLowerCase()).startsWith(myProject.toLowerCase())})
    return (
        <React.Fragment>
            <GlobalStyles styles={{ ul: { margin: 0, padding: 0, listStyle: 'none' } }} />
            
            { myList && (myList.length > 0) &&
              <Container maxWidth="lg" sx={{ my:  5}}>
                  <Stack direction={'row'} spacing={5} justifyContent="start"
                        alignItems="start">
                    <div style={{flex: 1}}/>

                    <div style={{display : "flex" , flexDirection : "row" , justifyContent : "space-between"}}>

                      
                    <Stack direction='row'  justifyContent="center" 
                   alignItems="center">
              <TextField value={myProject} 
               onChange={(e) => setMyProject(e.target.value)}
               onKeyDown={(e) => {
                  if (e.code === "Enter") {
                    searchMyProject()
                  }
                }}
                 sx={{width:'90%', textAlign:'left', outline:'none'}} size={"small"}/>
              <Button variant={'contained'} sx={{ borderRadius: 0, boxShadow:'none', py: 1.15}} size={"small"} onClick={searchMyProject}><SearchIcon/></Button>
            </Stack>
                        {/* <Autocomplete spacing={2} sx={{ width: 300 }}
                        freeSolo
                        id="free-solo-2-demo"
                        disableClearable
                        options={ ["all" , ...myList.map((option) => option.title)]}
                        value = {myProject}
                        onChange={(e , newValue) => { setMyProject(newValue)}}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label=  {<SearchIcon />}
                            InputProps={{
                              ...params.InputProps,
                              type: 'search',
                            }}/>
                            )}
                        /> */}
                        
                      
                      {/* <small>View:</small> */}
                      {''}
                      <IconButton size={'small'} color={'primary'} sx={{
                        opacity: view === 'Grid'? 1 : .5
                      }} onClick={() => setView('Grid')}>
                        <GridViewSharpIcon />
                      </IconButton>
                      {/* | */}
                      <IconButton size={'small'} color={'primary'}  sx={{
                        opacity: view == 'List'? 1 : .5
                      }} onClick={() => setView('List')}>
                        <ReorderSharpIcon />
                      </IconButton>
                      {''}
                    </div>

                  </Stack>

              </Container>
            }
            {loading ?
              <Container maxWidth="lg" sx={{ pb:5}}>
                <CircularProgress />
              </Container> :

             (
              <div>
                { myList && (myList.length > 0) &&
                  <Container maxWidth="lg" sx={{textAlign: 'left', pb:5}}>
                  <Stack direction={"row"} spacing={3}  justifyContent="flex-start"
                         alignItems="center" mb={1}>
                    <Typography  color={'primary'} sx={{mt: -17,fontSize:"38px"}}>
                      {projectPattern.test(location.pathname) ?  'My projects ' : 'All Projects'}
                    </Typography>
                    {!projectPattern.test(location.pathname) && profile.userType === 'artist' && <Button variant={'contained'} color={'warning'} sx={{px: 3}}  onClick={() => navigator('/artists/post-list-service')}>List service</Button>}

                  </Stack>


                  <Grid container spacing={3} alignItems="start" >

                  </Grid>
                  <Typography variant={'h4'} color={'primary'} sx={{mb:5}}>
                    <Typography variant={'h4'} color={'primary'} sx={{mb:5,mt:3}}>
                      {projectPattern.test(location.pathname)?"":""}
                    </Typography>
                    <Grid container spacing={3} alignItems="start" >

                      {myList && myList.length > 0 && myFilteredProjects.map((d) => {

                        return view === 'List' ?<ProjectListItem
                            image={d.mediaFiles.image}
                            key={d.id}
                            id={d.id}
                            title={d.title}
                            genre={d.genre}
                            posted={ moment(d.createdAt.seconds * 1000).format('MMM DD, YYYY | HH:mm')}
                            director={d?.directors && d?.directors?.length > 0 ? d?.directors[0].director :'Robert Eggers'}
                        />: <ProjectGridItem
                            image={d.mediaFiles.image}
                            key={d.id}
                            id={d.id}

                            title={d.title}
                            genre={d.genre}
                            posted={moment(d.createdAt.seconds * 1000).format('MMM DD, YYYY')}
                            director={d?.directors && d?.directors?.length > 0 ? d?.directors[0].director :'Robert Eggers'}
                        />
                      })

                      }

                    </Grid>
                  </Typography>
                </Container>
                }

<Container maxWidth="lg" sx={{ my:  5}}>
        <Stack direction={'row'} spacing={5} justifyContent="start"
               alignItems="start">
          <div style={{flex: 1}}/>

          <div style={{display : "flex" , flexDirection : "row" , justifyContent : "space-between"}}>

            
          <Stack direction='row'  justifyContent="center"
                   alignItems="center">
              <TextField value={searchProject}
               onChange={(e) => setSearchProject(e.target.value)}
               onKeyDown={(e) => {
                  if (e.code === "Enter") {
                    search()
                  }
                }}
                 sx={{width:'90%', textAlign:'left', outline:'none'}} size={"small"}/>
              <Button variant={'contained'} sx={{ borderRadius: 0, boxShadow:'none', py: 1.15}} size={"small"} onClick={search}><SearchIcon/></Button>
            </Stack>
              {/* <Autocomplete spacing={2} sx={{ width: 300 }}
              freeSolo
              id="free-solo-2-demo"
              disableClearable
              options={ ["all" , ...list.map((option) => option.title)]}
              value = {searchProject}
              onChange={(e , newValue) => { setSearchProject(newValue)}}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label=  {<SearchIcon />}
                  InputProps={{
                    ...params.InputProps,
                    type: 'search',
                  }}/>
                  )}
              /> */}
              
            
            {/* <small>View:</small> */}
            {''}
            <IconButton size={'small'} color={'primary'} sx={{
              opacity: viewProject === 'Grid'? 1 : .5
            }} onClick={() => setViewProject('Grid')}>
              <GridViewSharpIcon />
            </IconButton>
            {/* | */}
            <IconButton size={'small'} color={'primary'}  sx={{
              opacity: viewProject == 'List'? 1 : .5
            }} onClick={() => setViewProject('List')}>
              <ReorderSharpIcon />
            </IconButton>
            {''}
          </div>

        </Stack>

      </Container>
                <Container maxWidth="lg" sx={{textAlign: 'left', pb:5, mt :-12, }}>
                  <Stack direction={"row"} spacing={3}  justifyContent="flex-start"
                        alignItems="center" mb={3}>
                    <Typography sx={{fontSize:"38px"}} color={'primary'}>
                      {projectPattern.test(location.pathname) ?  'Projects that may interest you' : 'All Projects'}
                    </Typography>
                    {!projectPattern.test(location.pathname) && profile.userType === 'artist' && <Button variant={'contained'} color={'warning'} sx={{px: 3}}  onClick={() => navigator('/artists/post-list-service')}>List service</Button>}

                  </Stack>
                  {!projectPattern.test(location.pathname) ?
                    <Stack direction={"row"} spacing={5}  justifyContent="flex-start"
                          alignItems="center" mb={3}>

                          <div style={filterStyleDiv}>
                          <select value={Region} onChange={selectRegion} style={filterStyleSelect} >
                              {geoTags.map((t) => (
                                  <option value={t}>{t}</option>
                              ))}
                          </select>
                          </div>
                          {profile.userType === "investor"  ?
                          <div style={filterStyleDiv}>
                        
                          <select value={band} onChange={selectBand} style={filterStyleSelect} >
                              {INVESTMENT_BANDS.map((band , i ) => (
                                  <option value={i}>
                                    {i === 0 ? `All Investment` : band.max == undefined ? `${numberFormatter(band.min)} - above`: `${numberFormatter(band.min)} - ${numberFormatter(band.max)}`}
                                  </option>
                              ))}
                          </select>
                          </div>

                          :<></>
                          }


                          <div style={filterStyleDiv}>
                          <select value={Genre} onChange={selectGenre} style={filterStyleSelect} >
                              {preTags.map((t) => (
                                  <option value={t}>{t}</option>
                              ))}
                          </select>
                          </div>

                          {/* <FormControl fullWidth>
                            <InputLabel id="demo-simple-select-label">Region</InputLabel>
                            <Select
                              labelId="demo-simple-select-label"
                              id="demo-simple-select"
                              value={Region}
                              // label="Region"
                              onChange={selectRegion}
                            >
                              {geoTags.map((t) => (
                                  <MenuItem value={t}>{t}</MenuItem>
                              ))}
                            </Select>
                          </FormControl> */}

                          {/* <FormControl fullWidth>
                            <InputLabel id="demo-simple-select-label">Investment Bands</InputLabel>
                            <Select
                              labelId="demo-simple-select-label"
                              id="demo-simple-select"
                              value={band}
                              label="Investment Bands"
                              onChange={selectBand}
                            >
                              {INVESTMENT_BANDS.map((band , i ) => (
                                  <MenuItem value={i}>
                                    {i === 0 ? `all` : band.max == undefined ? `${band.min}-above`: `${band.min}-${band.max}`}
                                  </MenuItem>
                              ))}
                            </Select>
                          </FormControl> */}

                          {/* <FormControl fullWidth>
                            <InputLabel id="demo-simple-select-label">Genre</InputLabel>
                            <Select
                              labelId="demo-simple-select-label"
                              id="demo-simple-select"
                              value={Genre}
                              label="Genre"
                              onChange={selectGenre}
                            >
                              {preTags.map((g) => (
                                  <MenuItem value={g}>{g}</MenuItem>
                              ))}
                            </Select>
                          </FormControl> */}

                    </Stack> :

                    <></>
                    }
                  <Grid container spacing={3} alignItems="start" >
                  </Grid>
                  <Typography variant={'h4'} color={'primary'} sx={{mb:5}}>
                    <Typography variant={'h4'} color={'primary'} sx={{mb:5,mt:3}}>
                      {projectPattern.test(location.pathname)?"":""}
                    </Typography>
                    <Grid container spacing={3} alignItems="start" >

                      {list && list.length > 0 && filteredProjects.map((d) => {

                        return viewProject === 'List' ?<ProjectListItem
                            image={d.mediaFiles.image}
                            key={d.id}
                            id={d.id}
                            title={d.title}
                            genre={d.genre}
                            posted={ moment(d.createdAt.seconds * 1000).format('MMM DD, YYYY | HH:mm')}
                            director={d?.directors && d?.directors?.length > 0 ? d?.directors[0].director :'Robert Eggers'}
                        />: <ProjectGridItem
                            image={d.mediaFiles.image}
                            key={d.id}
                            id={d.id}

                            title={d.title}
                            genre={d.genre}
                            posted={moment(d.createdAt.seconds * 1000).format('MMM DD, YYYY')}
                            director={d?.directors && d?.directors?.length > 0 ? d?.directors[0].director :'Robert Eggers'}
                        />
                      })

                      }

                      

                    </Grid>
                  </Typography>
                </Container>
              </div>

             )

            }

            <Dialog
              open={open}
              onClose={() => setOpen(false)}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
              maxWidth='lg'
            >
              <DialogTitle id="alert-dialog-title" >
                <Stack direction={'row'} spacing={2}>
                  <Typography variant={'h6'} sx={{flex:1}}>You are almost there...</Typography>
                  <IconButton sx={{color:'rgba(0, 0, 0, 0.87)'}} onClick={() => setOpen(false)}>
                    <CloseIcon/>
                  </IconButton>
                </Stack>


              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description" >
                  <Typography variant={'body2'}>Would you like to finish setting up your profile before browsing through projects?</Typography>
                </DialogContentText>
              </DialogContent>
              <DialogActions sx={{paddingX: 3, paddingY: 2}}>
                <Button onClick={() => setOpen(false)} size={'small'} sx={{color: '#000',paddingX: 3}}>Not now</Button>
                <Button  variant={'contained'} color={'warning'} sx={{paddingX: 3}} size={'small'} onClick={() => {
                  setOpen(false);
                  if (profile?.userType === 'investor') navigator('/investor/profile');
                  else navigator('/artists/profile');
                }}>
                  Setup profile
                </Button>
              </DialogActions>
            </Dialog>

        </React.Fragment>
    )
}
